import AlfaBank from './AlfaBank';

export default AlfaBank;
